// extracted by mini-css-extract-plugin
export default {"blanket":"popup_blanket__rwiuQ","container":"popup_container__+aoZ1","mobile_view":"popup_mobile_view__t5RJK","close":"popup_close__-k2oG"};